import { whatsAppLink } from "../../components/Buttons/Whatsapp/Whatsapp.js";
import "../Services/FinalQuote.css";

const FinalQuote = () => {
  return (
    <div id="final-quote" className="">
      <div className="final-quote-container">
        <div className="final-quote-photo">

        </div>
        <div className="final-quote-text">
          <span>
            Atravessar esse caminho pode parecer  desafiador, complexo, até mesmo assustador, mas você não estará sozinho(a).
          </span>
        <div className="final-quote-button">
            <a href={whatsAppLink} target="_blank" rel="noopener noreferrer" className="button" >
                <button>
                    Agende sua Sessão
                </button>
            </a>
        </div>
        </div>
      </div>
    </div>
  );
}

export default FinalQuote;
